import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class BanditCampMediumSalvageableTileEntity extends TileEntity {
	public static readonly frameName = FrameName.BANDIT_CAMP_MEDIUM;
}

export default BanditCampMediumSalvageableTileEntity;
